import state from './store/state';
import getters from './store/getters';
import mutations from './store/mutations';
import actions from './store/actions';

export const name = '$_studentCompuHistory';

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
